"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANG_LT_TRANS = {
    'time picker': 'Laiko pasirinkimas',
    'today': 'Šiandien',
    'set time': 'Nustatyti laiką',
    'close': 'Uždaryti',
    'cancel': 'Panaikinti',
    'confirm': 'Patvirtinti',
    'hour': 'Valanda',
    'minute': 'Minutė',
    'second': 'Sekudnė',
};
//# sourceMappingURL=lt.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ng-pick-datetime/locale/lt.js
// module id = ../../../../ng-pick-datetime/locale/lt.js
// module chunks = 15